import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-build-and-buy',
  templateUrl: './build-and-buy.component.html',
  styleUrls: ['./build-and-buy.component.scss']
})
export class BuildAndBuyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  public buildBuyHeaderLabel= {
    balconySlidingDoor: "Balcony/Sliding Doors",
    glassVent: "GLASSvent",
    impactEntrances: "Impact Entrances",
    swingEntrances: "Swing Entrances",

  }
}
